module.exports = __webpack_public_path__ + "img/vitara-color.ac7d4bd6.svg";